// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__mVIYM","searchInput":"Search_searchInput__JV0cW","icon":"Search_icon__XMmYc","clearIcon":"Search_clearIcon__eIw10","hint":"Search_hint__1Fq-I"};